<template>
    <div>

        <question-list-block
            ref="questionListBlockRef"
            :questions="sharedQuestionList"
            :title="text('db.product.PROD_TITLE_SHA')"
            :questionsCountAnswered="getSharedQuestionsCountAnswered"
            :questionsCountTotal="getSharedQuestionsCountTotal"
            titleClasses="symptom-name font-weight-bold font-size-medium text-transform-none"
            @onProvideAnswer="handleProvideAnswer"
            @emitQuestionClick="onQuestionClick"
            :shortcutNav="shortcutNav">
        </question-list-block>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import SymptomQuestionItem from "../../../../common/components/shared/SymptomQuestionItem";
    import { mapGetters } from 'vuex';
    import RadialProgressSvg from "../../../../common/components/svg/productList/radialProgress";
    import QuestionListBlock from "../../../../common/components/shared/QuestionListBlock";

    export default {
        name: 'SharedQuestions',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock
        },

        props: ["shortcutNav"],

        computed: mapGetters({
            sharedQuestionList: 'SymptomsQuestionsStore/getSharedQuestionList',
            getSharedQuestionsCountAnswered: 'SymptomsQuestionsStore/getSharedQuestionsCountAnswered',
            getSharedQuestionsCountTotal: 'SymptomsQuestionsStore/getSharedQuestionsCountTotal',
        }),
        methods: {
            handleProvideAnswer(data) {
                this.$store.dispatch('SymptomsQuestionsStore/submitSharedQuestionAnswer', data).then((response) => {
                    this.$emit('emitChangeAnswer', data);
                });
            },

            onQuestionClick(data) {

                data.crtPanel = "SHARED_QUESTIONS";
                this.$emit('emitQuestionClick', data);
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-panels/SharedQuestions.vue